// extracted by mini-css-extract-plugin
export default {"pageTitle":"tabs_pageTitle__c3mnY","tabs":"tabs_tabs__ZVYrr","selected":"tabs_selected__zNQ1n","siteWidth":"tabs_siteWidth__YBmY9"};